document.getElementById('buyNowBtn').addEventListener('click', function () {

  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  /* ========== VARIANT AUTO SELECT FIX ========== */
  let variantInput = form.querySelector('input[name="id"]');

  // If variant not selected → auto select first available
  if (!variantInput || !variantInput.value) {
    const firstVariant = form.querySelector('select[name="id"] option:not([disabled])');
    if (firstVariant) {
      firstVariant.selected = true;
      firstVariant.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Re-check variant
  variantInput = form.querySelector('input[name="id"], select[name="id"]');
  if (!variantInput || !variantInput.value) {
    alert('Please select a variant');
    return;
  }

  /* ========== ADD TO CART & REDIRECT ========== */
  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(() => {
    window.location.href = '/checkout';
  })
  .catch(err => console.error(err));

});
